import Help from "./Help/Help";
import Landing from "./Landing/Landing";
import Pricing from "./Pricing/Pricing";

export const MarketingSections = {
  Help,
  Landing,
  Pricing,
};
